import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import { Formik, Form } from 'formik';

import i18n from 'i18n-js';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';

import { VehiclesSelect } from 'components/AsyncFields';

import { BaseModal } from 'components/UI';

// Validation schema of update user form
const UpdateReservationSchema = Yup.object().shape({
  vehicle_id: Yup.number().required(i18n.t('common.required_field')),
});

const ChangeVehicleModal = ({
  open,
  vehicleId,
  vehicle,
  handleClick,
  onSubmit,
  privileges,
  vehicle_group_id,
  fetchedChangeVehicle,
  fetchingChangeVehicle,
}) => {
  const formRef = useRef(null);

  // Initials values of the form
  const initialValues = {
    vehicle_id: vehicleId || '',
  };

  useEffect(() => {
    if (fetchedChangeVehicle) {
      handleClick();
    }
  }, [fetchedChangeVehicle, handleClick]);

  const handleSubmit = () => {
    formRef.current.submitForm();
  };

  return (
    <BaseModal
      size="md"
      open={open}
      maxWidth={480}
      hasEnterButton
      hasCancelButton
      onEnter={handleSubmit}
      onCancel={handleClick}
      closeButtonType="icon"
      enableCloseButton={false}
      loading={fetchingChangeVehicle}
      title={i18n.t('vehicle.change_vehicle')}
      enterButtonLabel={i18n.t('common.change')}
      privileges={privileges}
    >
      <Grid container direction="column" data-cy="change-vehicle-modal" alignItems="flex-start">
        <Box width="100%">
          {vehicle && (
            <Grid container spacing={2}>
              <Grid item xs={4}>
                <h4
                  style={{
                    fontWeight: 500,
                  }}
                >
                  {i18n.t('vehicle.current_vehicle')}
                </h4>
              </Grid>
              <Grid item xs={8}>
                <p
                  style={{
                    textAlign: 'right',
                  }}
                >
                  {vehicle?.display_name}
                </p>
              </Grid>
            </Grid>
          )}
          <Formik
            innerRef={formRef}
            initialValues={initialValues}
            validationSchema={UpdateReservationSchema}
            onSubmit={onSubmit}
          >
            {({ handleSubmit, values, setFieldValue }) => (
              <Form noValidate onSubmit={handleSubmit}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Box>
                      <VehiclesSelect
                        label={'Vehicle'}
                        form={{ setFieldValue }}
                        vehicle_group_id={vehicle_group_id}
                        field={{
                          name: 'vehicle_id',
                          value: values.vehicle_id || '',
                        }}
                      />
                    </Box>
                  </Grid>
                </Grid>
              </Form>
            )}
          </Formik>
        </Box>
      </Grid>
    </BaseModal>
  );
};

ChangeVehicleModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClick: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  privileges: PropTypes.object,
  vehicle: PropTypes.object,
  vehicle_group_id: PropTypes.number,
  fetchedChangeVehicle: PropTypes.bool,
  fetchingChangeVehicle: PropTypes.bool,
};

ChangeVehicleModal.defaultProps = {
  open: false,
  handleClick: () => {},
  fetchedChangeVehicle: false,
  fetchingChangeVehicle: false,
  privileges: {},
};

export default ChangeVehicleModal;
